// extracted by mini-css-extract-plugin
export default {"content":"_1BE94P9fPC","message-icon":"bBTTVUmuKT","messageIcon":"bBTTVUmuKT","not-available":"_1ZCdS-JYuZ","notAvailable":"_1ZCdS-JYuZ"};
    if(module.hot) {
      // 1623933219284
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  